import { Button, type ButtonProps } from "react-bootstrap";
import { MdCloudDownload } from "react-icons/md";

const DownloadButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdCloudDownload /> {children}
  </Button>
);

export default DownloadButton;
